export default __webpack_public_path__ + "static/media/Slide20.13f00177.jpg";